import * as yup from 'yup';
import { regExIdentifiers, validationMessages } from '../../../../constants';
import { numericSchemaTest, themeObject } from '../../../../lib';

export interface PredictDictionaryFormInputs {
    description?: string;
    maxNumberOfRows?: string;
    sheetName?: string;
    sheetNumber?: string;
}

export const PredictDictionarySchema = yup.object({
    description: yup.string().optional(),
    maxNumberOfRows: numericSchemaTest(
        validationMessages.maxNumberOfRows,
        regExIdentifiers.maxNumberOfRows,
        true
    ),
    sheetName: yup.string().optional(),
    sheetNumber: numericSchemaTest(
        validationMessages.invalidNumber,
        regExIdentifiers.nonRequiredNumbers,
        true
    ),
});

export const predictDictionaryDefaults = {};

export type PredictRadioButtons = '' | 'sheetName' | 'sheetNumber';

export const predictDictionaryRadioButtons: {
    label: string;
    value: string;
}[] = [
    {
        label: 'Sheet Name',
        value: 'sheetName',
    },
    {
        label: 'Sheet Number',
        value: 'sheetNumber',
    },
];

export const predictDictionaryStyles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        mt: 1.5,
        mx: '143.5px',
    },
    fieldContainer: {
        mt: 2,
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    customChipField: {
        width: '100%',
    },
    descriptionFieldContainer: {
        mt: 3,
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    maxNumberOfRowsField: {
        mt: 2,
        width: '100%',
    },
    radioButtonFormControlLabelContainer: {
        display: 'flex',
        flexDirection: 'column',
        ml: 2,
    },
    radioButtonFieldContainer: {
        ml: 2.25,
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    radioButton: {
        '.MuiFormControlLabel-root': {
            mr: 0,
        },
        '.MuiFormControlLabel-label': {
            ...themeObject.typography.inputLabel,
            lineHeight: '21.17px',
            letterSpacing: '0.15px',
            color: themeObject.palette.grayScale[800],
        },
    },
    subHeadingTextStyles: {
        ...themeObject.typography.body.default,
        ...themeObject.typography.body.body1,
        ...themeObject.typography.body.regular,
        lineHeight: '21.17px',
        textAlign: 'center',
        color: themeObject.palette.grayScale[800],
    },
    containerStyles: {
        width: '100%',
        mt: 2,
    },
    popperStyles: {
        width: '257px',
        height: '88px',
    },
};
